export default {
  manifest: {
    title: 'Descubre iniciativas de ESG que guían nuestras acciones',
    desc: 'Nuestro compromiso con prácticas responsables y transparentes',
    button: 'Nuestro Manifiesto',
  },
}
